<template>
  <teleport to="body">
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in-out duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="visible"
        class="fixed inset-0 z-300 bg-transparent-70"
        @click="closeBackdrop($event)"
      >
        <transition
          enter-active-class="transition ease-out duration-200 transform delay-200"
          enter-from-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-200 transform"
          leave-from-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div
            v-show="visible"
            ref="sideModal"
            v-bind="$attrs"
            class="relative w-280px flex flex-col bg-white px-32px"
          >
            <i
              class="icon-close absolute right-16px top-16px cursor-pointer text-24px text-primary-80"
              @click="$emit('update:visible', false)"
            />
            <slot />
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'update:visible': [value: boolean]
}>()

const sideModal = useTemplateRef<HTMLElement>('sideModal')

// TODO: chili 回來時要檢查這邊要不要 refactor 修正他
// https://gitlab.com/evolutivelabs/amuse/ditto/ditto-web/-/merge_requests/533#note_1569160817
function closeBackdrop(e: Event): void {
  if (sideModal.value == null || e.composedPath().includes(sideModal.value)) {
    return
  }
  emit('update:visible', false)
}
</script>
